import React, { useState } from 'react';

const EntityEditContext = React.createContext([ null, null, null, null]);

export default EntityEditContext